import { render } from "./SwitchLanguage.vue?vue&type=template&id=43697223"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__